import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSetRecoilState } from 'recoil'
import { loaderState } from 'recoils/atoms'

import { Button } from 'components'
import { IconDownload } from 'components/Icons'
import { StockKeepingUnitService } from 'features/StockKeepingUnit'

export const StockKeepingUnitDownloadReport: React.FC = () => {
  const { t } = useTranslation('product')

  const setLoader = useSetRecoilState(loaderState)

  const base = 'con-stock-keeping-unit'

  const handleClick = async () => {
    setLoader(true)
    await StockKeepingUnitService.downloadProductExport()
    setLoader(false)
  }

  return (
    <div className={`${base}__download-report`}>
      <Button
        variants='outline'
        withIcon={<IconDownload />}
        onClick={handleClick}
      >
        {t('exportCSV.button')}
      </Button>
    </div>
  )
}

export default StockKeepingUnitDownloadReport
